<script>
    export let index;
    export let player_name;
    export let player_image;
    export let positions;
    export let salary;
    export let projection;
    export let included;
    export let rosterPlayer;
    export let excludePlayer;
    export let includePlayer;
    export let rosterable = "";
    export let inj_tag = "H";
    export let game_details;
    export let player;
    export let showPlayerModal;
</script>
<style>
    .unrosterable{
        opacity: 0.5;
    }
</style>
<div class="{rosterable} row border-top border-start border-end">
    <div class="col-9">
        <div class="row">
            <div class="col-4 pt-1 mt-auto px-0 text-center">
                <img alt="{player_name}" style="object-fit: contain;" loading="lazy" height="65" width="89" src="{player_image}" onerror="this.src='https://dfstud.nyc3.digitaloceanspaces.com/dfstud/static/fantasy/img/brand/horse_default_profile2.png';">
            </div>
            <div class="col-8">
                <div class="d-flex flex-column">
                    <div style="cursor: pointer;" on:click={()=>{showPlayerModal(player)}}>
                        <span class="bg-light px-1 border">{positions}</span> <span class="text-primary fw-normal">{player_name}</span>
                    </div>
                </div>
                <div>
                    <span class="text-success">💸{salary.toLocaleString()}</span> | 
                    <span class="text-primary">📊{projection}</span>
                    <span>
                        {#if inj_tag == "O"}
                        <span class="badge bg-danger">OUT</span>
                        {:else if inj_tag == "Q" || inj_tag == "D" || inj_tag == "GTD"}
                        <span class="badge bg-warning">{inj_tag}</span>
                        {/if}
                    </span>
                </div>
                <div>
                    <span class="text-secondary">{@html game_details}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-3 p-0 pe-1 my-auto ms-auto">
        <div>
            <div class="flex-wrap btn-group w-100 shadow" role="group" aria-label="Basic example">
                {#if included}
                <button on:click={()=>rosterPlayer(index)} type="button" class="btn btn-primary">🔒</button>
                <button on:click={()=>excludePlayer(index)} type="button" class="btn btn-danger">✖️</button>
                {:else}
                <button on:click={()=>includePlayer(index)} type="button" class="btn btn-success">✔️</button>
                {/if}
            </div>
        </div>
    </div>
</div>